export default "__VITE_ASSET__B5K$Wly3__"